import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { mockSubmitForm } from '../../data/mock';
import { Loader2, Check } from 'lucide-react';

const ComingSoonSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    installerType: '',
    suburb: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const installerTypes = [
    'Solar Installer',
    'Battery Installer',
    'Electrician',
    'HVAC Installer',
    'Field Service Technician',
    'Other',
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await mockSubmitForm('comingSoon', formData);
    setIsSubmitting(false);
    setIsSubmitted(true);
  };

  return (
    <section className="section-padding bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-[#0D9488]/20 text-[#14B8A6] rounded-full text-sm font-medium mb-4">
              Coming Soon
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white">
              Integrated delivery + recovery
            </h2>
            <p className="mt-6 text-lg text-[#94A3B8] leading-relaxed">
              If your retailer routes deliveries through Transa, we may be able to reduce 
              your recovery cost due to combined logistics. Drop equipment off and pick up 
              packaging in one visit.
            </p>
            <div className="mt-6 p-4 bg-[#1F2937] rounded-xl border border-[#374151]">
              <p className="text-sm text-[#94A3B8]">
                Register your interest to be notified when this service launches in your area.
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="bg-[#1F2937] rounded-2xl p-8 border border-[#374151]">
            {isSubmitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 rounded-full bg-[#0D9488]/20 flex items-center justify-center mx-auto mb-4">
                  <Check className="w-8 h-8 text-[#0D9488]" />
                </div>
                <h3 className="text-xl font-bold text-white">Thanks for your interest!</h3>
                <p className="mt-2 text-[#94A3B8]">
                  We'll notify you when integrated delivery + recovery launches.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <h3 className="text-lg font-semibold text-white mb-6">Register Interest</h3>
                
                <div>
                  <Input
                    type="text"
                    placeholder="Name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="bg-[#111111] border-[#374151] text-white placeholder:text-[#64748B] focus:border-[#0D9488]"
                    required
                  />
                </div>
                
                <div>
                  <Input
                    type="tel"
                    placeholder="Mobile"
                    value={formData.mobile}
                    onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                    className="bg-[#111111] border-[#374151] text-white placeholder:text-[#64748B] focus:border-[#0D9488]"
                    required
                  />
                </div>
                
                <div>
                  <Input
                    type="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="bg-[#111111] border-[#374151] text-white placeholder:text-[#64748B] focus:border-[#0D9488]"
                    required
                  />
                </div>
                
                <div>
                  <Select
                    value={formData.installerType}
                    onValueChange={(value) => setFormData({ ...formData, installerType: value })}
                  >
                    <SelectTrigger className="bg-[#111111] border-[#374151] text-white focus:border-[#0D9488]">
                      <SelectValue placeholder="Installer type" />
                    </SelectTrigger>
                    <SelectContent>
                      {installerTypes.map((type) => (
                        <SelectItem key={type} value={type}>
                          {type}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Input
                    type="text"
                    placeholder="Suburb"
                    value={formData.suburb}
                    onChange={(e) => setFormData({ ...formData, suburb: e.target.value })}
                    className="bg-[#111111] border-[#374151] text-white placeholder:text-[#64748B] focus:border-[#0D9488]"
                    required
                  />
                </div>
                
                <Button 
                  type="submit" 
                  className="w-full bg-[#0D9488] hover:bg-[#0F766E] text-white h-12 mt-4"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin mr-2" />
                      Submitting...
                    </>
                  ) : (
                    'Register Interest'
                  )}
                </Button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoonSection;
